import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { categoryDetailSubCategoriesStyles } from "@insite/content-library/Widgets/Category/CategoryDetailSubCategories";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

categoryDetailSubCategoriesStyles.subCategoryNameLink = mergeToNew(
    categoryDetailSubCategoriesStyles.subCategoryNameLink,
    {
        color: "text.accent",
    },
);

categoryDetailSubCategoriesStyles.innerContainer = mergeToNew(categoryDetailSubCategoriesStyles.innerContainer, {
    offsetCss: css`
        width: 100% !important;
    `,
});

categoryDetailSubCategoriesStyles.subCategoryNameLinkItem = mergeToNew(
    categoryDetailSubCategoriesStyles.subCategoryNameLinkItem,
    {
        css: css`
            padding: 0 8px 8px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        justify-content: center;
                    `,
                    css`
                        justify-content: center;
                    `,
                    css`
                        justify-content: center;
                    `,
                ])}
        `,
    },
);

categoryDetailSubCategoriesStyles.subCategoryNameLinkItem = mergeToNew(
    categoryDetailSubCategoriesStyles.subCategoryNameLinkItem,
    {
        width: [9, 9, 12, 12, 12],
    },
);

categoryDetailSubCategoriesStyles.subCategoryImageItem = mergeToNew(
    categoryDetailSubCategoriesStyles.subCategoryImageItem,
    {
        width: [3, 3, 12, 12, 12],
    },
);
